/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type RequestedDocumentWritable = {
  readonly id?: number;
  readonly is_uploaded?: string;
  document_request?: number | null;
  files?: Array<number>;
  readonly created_at?: string;
  readonly updated_at?: string;
  name: string;
  is_deleted?: boolean | null;
  readonly deleted_at?: string | null;
  tags?: string | null;
  reference_object_type?: RequestedDocumentWritable.reference_object_type | null;
  reference_object_id?: number | null;
  company_requested_document?: number | null;
  company_information_request_status?: number | null;
  source_requested_file?: number | null;
  folder?: number | null;
};
export namespace RequestedDocumentWritable {
  export enum reference_object_type {
    CT = 'ct',
    FI = 'fi',
    FO = 'fo',
    CB = 'cb',
    EV = 'ev',
    SSV = 'ssv',
    MA = 'ma',
    FIO = 'fio',
  }
}

